export function formatPropertyAccess(objectName: string, key: string): string {
  return /^[A-Za-z_$][\w$]*$/.test(key)
    ? `${objectName}.${key}`
    : `${objectName}[${JSON.stringify(key)}]`
}
